import React from 'react';
import axios from 'axios';
import Modal from '@mui/material/Modal';
import styled from 'styled-components';
import { API_BASE_URL } from '../../../config/apiConfig';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';

// Giveaway images
import iphone17 from '../../../assets/Giveaway Product Images/iPhone 17 Series.png';
import ultravioletteTesseract from '../../../assets/Giveaway Product Images/Ultraviolette Tesseract Electric Scooter.webp';
import ultravioletteShockwave from '../../../assets/Giveaway Product Images/Ultraviolette Shockwave Electric Bike.avif';
import ultravioletteF77 from '../../../assets/Giveaway Product Images/Ultraviolette F77 Mach 2 Electric Bike.png';
import sonyPs5 from '../../../assets/Giveaway Product Images/Sony Playstation 5.png';
import kineticDx from '../../../assets/Giveaway Product Images/Kinetic DX Electric Scooter.png';
import pixel10 from '../../../assets/Giveaway Product Images/Google Pixel 10 Series Smartphones.png';
import bmwCe02 from '../../../assets/Giveaway Product Images/BMW CE02 Electric Bike.avif';
import ather450x from '../../../assets/Giveaway Product Images/Ather 450x Electric Scooter.webp';
import appleMacbooks from '../../../assets/Giveaway Product Images/Apple Macbooks.webp';
import alienwareLaptops from '../../../assets/Giveaway Product Images/Alienware Laptops.avif';

function Merch() {
  const navigate = useNavigate();
  const giveawayItems = [
    { name: 'iPhone 17 Series', image: iphone17 },
    { name: 'Ultraviolette Tesseract Electric Scooter', image: ultravioletteTesseract },
    { name: 'Ultraviolette Shockwave Electric Bike', image: ultravioletteShockwave },
    { name: 'Ultraviolette F77 Mach 2 Electric Bike', image: ultravioletteF77 },
    { name: 'Sony PlayStation 5', image: sonyPs5 },
    { name: 'Google Pixel 10 Series Smartphones', image: pixel10 },
    { name: 'BMW CE02 Electric Bike', image: bmwCe02 },
    { name: 'Ather 450x Electric Scooter', image: ather450x },
    { name: 'Apple MacBooks', image: appleMacbooks },
    { name: 'Alienware Laptops', image: alienwareLaptops }
  ];
  const [showTCModal, setShowTCModal] = React.useState(false);
  const [showConfetti, setShowConfetti] = React.useState(false);
  const [answers, setAnswers] = React.useState({
    q1: '',
    q2: '',
    q3: ''
  });
  const [error, setError] = React.useState('');
  const [giveawayStatus, setGiveawayStatus] = React.useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [baseRotation, setBaseRotation] = React.useState(0);
  const [isSubscriptionActive, setIsSubscriptionActive] = React.useState(false);
  const [isSubscriptionWaived, setIsSubscriptionWaived] = React.useState(false);

  const correctAnswers = {
    q1: 'Most organized consumer community in the world',
    q2: 'Discover deals based on person\'s preference',
    q3: 'Save & Splurge'
  };

  React.useEffect(() => {
    const checkGiveawayStatus = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const response = await axios.get(`${API_BASE_URL}/user/giveaway`, {
          headers: { Authorization: token }
        });
        const giveawayData = response.data.data;
        setGiveawayStatus(giveawayData);
        if (giveawayData && giveawayData.length > 0 && giveawayData[0]?.passed) {
          setShowConfetti(true);
        }
      } catch (error) {
        console.error('Error fetching giveaway status:', error);
      }
    };
    checkGiveawayStatus();
  }, []);

  // Initial 360 degree spin on mount
  React.useEffect(() => {
    // Delay slightly to ensure transition is visible
    setTimeout(() => {
      setBaseRotation(360);
    }, 100);
  }, []);

  // Auto-switch timer every 3 seconds
  React.useEffect(() => {
    const timer = setInterval(() => {
      setSelectedIndex(prev => (prev + 1) % giveawayItems.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [giveawayItems.length]);

  React.useEffect(() => {
    const checkSubscriptionStatus = async () => {
      try {
        const token = sessionStorage.getItem('token');
        if (!token) {
          setIsSubscriptionActive(false);
          setIsSubscriptionWaived(false);
          return;
        }
        const res = await axios.get(`${API_BASE_URL}/subscription/current`, {
          headers: { Authorization: token }
        });
        const data = res?.data?.data;
        const has = !!data?.has_subscription;
        const sub = data?.subscription;
        const active = has && sub && (sub.status === 'active');
        const waived = has && sub && sub.waived === true;
        setIsSubscriptionActive(!!active);
        setIsSubscriptionWaived(!!waived);
      } catch (e) {
        setIsSubscriptionActive(false);
        setIsSubscriptionWaived(false);
      }
    };
    checkSubscriptionStatus();
  }, []);

  const handleAnswerChange = (question, answer) => {
    setAnswers(prev => ({
      ...prev,
      [question]: answer
    }));
  };

  const handleSubmit = async () => {
    if (!answers.q1 || !answers.q2 || !answers.q3) {
      setError('Please answer all questions');
      return;
    }

    const isCorrect =
      answers.q1 === correctAnswers.q1 &&
      answers.q2 === correctAnswers.q2 &&
      answers.q3 === correctAnswers.q3;

    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.post(`${API_BASE_URL}/user/giveaway`, {
        q1: { question: "What is Spoelt's vision?", answer: answers.q1 },
        q2: { question: "What is the benefit of being part of the Spoelt community?", answer: answers.q2 },
        q3: { question: "How many user personas does Spoelt cater to?", answer: answers.q3 },
        isCorrect
      }, {
        headers: { Authorization: token, 'Content-Type': 'application/json' }
      });

      if (isCorrect) {
        setShowTCModal(false);
        setGiveawayStatus([{ passed: true }]);
        setShowConfetti(true);
      } else {
        setGiveawayStatus([{ passed: false }]);
        setError('Some answers are incorrect. Please try next time.');
      }
    } catch (error) {
      console.error('Error submitting answers:', error);
      setError('There was an error submitting your answers. Please try again.');
    }
  };

  const renderGiveawayStatus = () => {
    if (Object.keys(giveawayStatus).length === 0 || giveawayStatus === null) {
      if (isSubscriptionActive || isSubscriptionWaived) {
        return (
          <button
            onClick={() => setShowTCModal(true)}
            style={{
              backgroundColor: '#e9fe53',
              border: '1px solid #202023',
              padding: '10px 30px',
              fontFamily: 'Metrophobic, sans-serif',
              cursor: 'pointer',
              fontWeight: '800'
            }}
          >
            ENTER NOW
          </button>
        );
      }
      return (
        <button
          onClick={() => navigate('/profile?section=subscription')}
          style={{
            backgroundColor: '#e9fe53',
            border: '1px solid #202023',
            padding: '10px 30px',
            fontFamily: 'Metrophobic, sans-serif',
            cursor: 'pointer',
            fontWeight: '800'
          }}
        >
          SUBSCRIBE NOW
        </button>
      );
    }

    return (
      <div style={{
        padding: '15px 30px',
        border: '1px solid #202023',
        fontFamily: 'Metrophobic, sans-serif',
        textAlign: 'center',
        background: '#fff'
      }}>
        {giveawayStatus[0].passed ?
          "Congratulations! You're entered in the giveaway!" :
          "Sorry, you answered incorrectly. Please try next time."
        }
      </div>
    );
  };

  return (
    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', backgroundColor: '#fff' }}>
      {showConfetti && <Confetti width={window.innerWidth} height={window.innerHeight} recycle={false} numberOfPieces={500} onConfettiComplete={() => setShowConfetti(false)} style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999 }} />}
      <MerchHeaderSection>
        <MerchTitle>
          MEMBER GIVEAWAY
        </MerchTitle>
      </MerchHeaderSection>

      <RotaryContainer id="giveaway-dial">
        <DialWrapper>
          <DialOuter style={{ 
            // baseRotation (360) + offset to align index 0 with finger stop (135) + relative movement (clockwise)
            transform: `rotate(${baseRotation + 135 + (selectedIndex * (360 / giveawayItems.length))}deg)`, 
            transition: 'transform 1s cubic-bezier(0.4, 0, 0.2, 1)' 
          }}>
            {giveawayItems.map((item, index) => {
              const totalItems = giveawayItems.length;
              // Place items in a clockwise sequence (negative index for angle calculation)
              const angle = (-index * (360 / totalItems)) - 90;
              const isMobile = window.innerWidth <= 768;
              const radius = isMobile ? 40 : 42; 
              
              return (
                <Hole 
                  key={index}
                  $active={selectedIndex === index}
                  onClick={() => setSelectedIndex(index)}
                  style={{
                    left: `${50 + radius * Math.cos(angle * Math.PI / 180)}%`,
                    top: `${50 + radius * Math.sin(angle * Math.PI / 180)}%`,
                    // Inverse rotate each hole to keep images upright (-DialRotation)
                    transform: `translate(-50%, -50%) rotate(-${baseRotation + 135 + (selectedIndex * (360 / giveawayItems.length))}deg)`
                  }}
                >
                  <img src={item.image} alt={item.name} />
                </Hole>
              );
            })}
          </DialOuter>
          <FingerStop />
          <DialInner>
            <SelectedImage 
              key={selectedIndex}
              src={giveawayItems[selectedIndex].image} 
              alt={giveawayItems[selectedIndex].name} 
            />
            <DialTextContent>
              <SelectedName>{giveawayItems[selectedIndex].name}</SelectedName>
            </DialTextContent>
          </DialInner>
        </DialWrapper>
        <MobileSelectedName>{giveawayItems[selectedIndex].name}</MobileSelectedName>
      </RotaryContainer>

      <MerchHero id="merch-action-info">
        <MerchActionRow>
          <MerchDescription>
            This members-only giveaway is your chance to win exclusive rewards from our most carefully curated collection yet.
          </MerchDescription>
          <MerchButton onClick={() => {
            if (isSubscriptionActive || isSubscriptionWaived) {
              if (giveawayStatus && giveawayStatus.length > 0) {
                if (giveawayStatus[0]?.passed) {
                  setShowConfetti(true);
                } else {
                  document.getElementById('giveaway-dial').scrollIntoView({ behavior: 'smooth' });
                }
              } else {
                setShowTCModal(true);
              }
            } else {
              navigate('/profile?section=subscription');
            }
          }}>
            {(isSubscriptionActive || isSubscriptionWaived) ? 
              (giveawayStatus && giveawayStatus.length > 0 ? 
                (giveawayStatus[0]?.passed ? "✓ SUCCESSFULLY ENTERED" : "VIEW STATUS") : 
                "ENTER NOW") : 
              "SUBSCRIBE TO ENTER"}
          </MerchButton>
        </MerchActionRow>
      </MerchHero>

      <Modal
        open={showTCModal}
        onClose={() => setShowTCModal(false)}
        aria-labelledby="tc-modal-title"
        aria-describedby="tc-modal-description"
      >
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: window.innerWidth <= 991 ? '20px' : '40px',
          maxWidth: '800px',
          maxHeight: '80vh',
          overflowY: 'auto',
          width: '80%',
          border: '1px solid #202023',
          fontSize: window.innerWidth <= 991 ? '14px' : '16px'
        }}>
          <h2 style={{ marginBottom: '20px', fontFamily: 'Metrophobic, sans-serif' }}>Giveaway T&C</h2>
          <div style={{ fontFamily: 'Metrophobic, sans-serif', lineHeight: '1.6', fontSize: window.innerWidth <= 991 ? '12px' : '16px' }}>
            <p>The 'Welcome to Spoelt' giveaway campaign will be enabled only after registering 10000 unique members. Each of the 10000 members will be intimated about the giveaway via email.</p>
            <br />
            <p>The 'Welcome to Spoelt' campaign is not a paid lottery or distribution of prizes by lot or chance to those persons participating in the chances of a prize by purchasing tickets. It is an exclusive giveaway to members who have subscribed to the Spoelt platform, to access curated community deals and have paid a subscription fee to access these curated deals. This will enable them to access the deals on the dealsboard and also qualify them for the 'Welcome to Spoelt' giveaway campaign. The giveaway is merely a bonus to the members choosing to access curated deals within the Spoelt community and not the main feature of the platform.</p>
            <br />
            <p>As part of the campaign, Spoelt will giveaway unique products and services in association/partnership with brands or independently and will incur the entire cost of promoting, acquiring and allotting the said products and services. The distribution and delivery of the giveaway will depend on the product and service each time, and the method including location and mode of delivery, decided by Spoelt will be final.</p>
            <br />
            <p>Products to be offered for the giveaway will be the Ultraviolette F77 Mach 2 recon and Ather 450X. Spoelt will issue a coupon code to the winners and they can pick up, customize by paying the additional cost (if they wish to) and get it delivered or collect it. (if delivery is not provided by the vendor).</p>
            <br />
            <p>25 members from the Spoelt community will be chosen to a giveaway of 25 products (1 for each winner) and will be given away as part of the 'Welcome to Spoelt' campaign along with the names of all the 10000 members on the Wall of Elts.</p>
            <br />
            <p>All eligible members will have to click 'I Agree' to the terms and conditions of the giveaway and answer 3 questions correctly to participate in the giveaway.</p>
          </div>

          <div style={{ marginTop: '30px', fontFamily: 'Metrophobic, sans-serif' }}>
            <h3 style={{ marginBottom: '20px' }}>Please answer these questions:</h3>
            
            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontWeight: 'bold' }}>Q1. What is Spoelt's vision?</p>
              <div style={{ marginLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '10px' }}>
                <label><input type="radio" name="q1" value="To be just another e-commerce platform" onChange={(e) => handleAnswerChange('q1', e.target.value)} /> To be just another e-commerce platform</label>
                <label><input type="radio" name="q1" value="Most organized consumer community in the world" onChange={(e) => handleAnswerChange('q1', e.target.value)} /> Most organized consumer community in the world</label>
                <label><input type="radio" name="q1" value="Fast delivery of electronics" onChange={(e) => handleAnswerChange('q1', e.target.value)} /> Fast delivery of electronics</label>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontWeight: 'bold' }}>Q2. What is the benefit of being part of the Spoelt community?</p>
              <div style={{ marginLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '10px' }}>
                <label><input type="radio" name="q2" value="Free shipping worldwide" onChange={(e) => handleAnswerChange('q2', e.target.value)} /> Free shipping worldwide</label>
                <label><input type="radio" name="q2" value="Discover deals based on person's preference" onChange={(e) => handleAnswerChange('q2', e.target.value)} /> Discover deals based on person's preference</label>
                <label><input type="radio" name="q2" value="Access to a generic blog" onChange={(e) => handleAnswerChange('q2', e.target.value)} /> Access to a generic blog</label>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontWeight: 'bold' }}>Q3. How many user personas does Spoelt cater to?</p>
              <div style={{ marginLeft: '20px', display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '10px' }}>
                <label><input type="radio" name="q3" value="Save & Splurge" onChange={(e) => handleAnswerChange('q3', e.target.value)} /> Save & Splurge</label>
                <label><input type="radio" name="q3" value="Only Splurge" onChange={(e) => handleAnswerChange('q3', e.target.value)} /> Only Splurge</label>
                <label><input type="radio" name="q3" value="Buyers and Sellers" onChange={(e) => handleAnswerChange('q3', e.target.value)} /> Buyers and Sellers</label>
              </div>
            </div>

            {error && <div style={{ color: 'red', marginBottom: '20px' }}>{error}</div>}
          </div>

          <button
            onClick={handleSubmit}
            style={{
              backgroundColor: '#e9fe53',
              border: '1px solid #202023',
              padding: '10px 30px',
              cursor: 'pointer',
              fontWeight: '800'
            }}
          >
            I AGREE
          </button>
        </div>
      </Modal>
    </div>
  );
}

const MerchHero = styled.div`
  width: 100%;
  padding: 40px 0 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #fff;
  @media (max-width: 768px) {
    padding: 20px 10px 60px;
  }
`;

const MerchHeaderSection = styled.div`
  width: 100%;
  padding: 24px 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #fff;
`;

const MerchBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  span { color: #202023; font-size: 14px; font-weight: 700; letter-spacing: 3px; text-transform: uppercase; }
  .line { height: 1px; width: 60px; background-color: #202023; }
`;

const MerchTitle = styled.h1`
  font-family: Metrophobic, sans-serif;
  font-size: 72px;
  font-weight: 900;
  color: #000;
  line-height: 1.1;
  text-transform: uppercase;
  margin-bottom: 20px;
  @media (max-width: 991px) { font-size: 60px; }
`;

const MerchActionRow = styled.div`
  display: flex;
  width: 100%;
  max-width: 900px;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  margin-bottom: 48px;
  @media (max-width: 768px) { flex-direction: column; align-items: center; text-align: center; gap: 40px; }
`;

const MerchDescription = styled.p`
  max-width: 450px;
  color: #555;
  font-family: Metrophobic, sans-serif;
  font-size: 18px;
  line-height: 1.6;
  border-left: 3px solid #000;
  padding-left: 20px;
`;

const MerchButton = styled.button`
  background-color: #e9fe53;
  color: #202023;
  border: 1px solid #202023;
  padding: 16px 40px;
  font-family: Metrophobic, sans-serif;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
  text-transform: uppercase;
`;

const ScrollExplore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  .text { color: #999; font-size: 12px; font-weight: 700; letter-spacing: 2px; }
  .scroll-line {
    width: 2px;
    height: 48px;
    background: linear-gradient(to bottom, #000 0%, transparent 100%);
  }
`;

const RotaryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0 40px;
  background-color: #fff;
  position: relative;
`;

const DialWrapper = styled.div`
  position: relative;
  width: 650px;
  height: 650px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    width: 320px;
    height: 320px;
  }
`;

const DialOuter = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: radial-gradient(circle, #b8b9be 0%, #8a8b8f 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 20px 50px rgba(0,0,0,0.3), inset 0 0 40px rgba(255,255,255,0.4);
  position: relative;
  border: 2px solid #7a7b7f;
`;

const DialInner = styled.div`
  width: 50%;
  height: 50%;
  border-radius: 50%;
  background-color: #fdfaf5;
  border: 4px solid #8d8e92;
  box-shadow: 
    inset 0 2px 15px rgba(0,0,0,0.1),
    0 4px 10px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  
  @media (max-width: 768px) {
    width: 40%; // Much smaller on mobile to show holes
    height: 40%;
  }
`;

const DialTextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 15px;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const UpgradeText = styled.div`
  display: none; // Removed as per request
`;

const SelectedImage = styled.img`
  width: 80%;
  height: 80%;
  object-fit: contain;
  transition: all 0.5s ease;
  animation: fadeIn 0.4s ease;
  @keyframes fadeIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
  
  @media (max-width: 768px) {
    width: 95%;
    height: 95%;
  }
`;

const SelectedName = styled.div`
  font-family: 'Metrophobic', sans-serif;
  font-weight: 800;
  font-size: 16px;
  margin-top: 20px;
  text-align: center;
  color: #202023;
  text-transform: uppercase;
  max-width: 200px;
`;

const MobileSelectedName = styled.div`
  display: none;
  font-family: 'Metrophobic', sans-serif;
  font-weight: 800;
  font-size: 18px;
  margin-top: 30px;
  text-align: center;
  color: #202023;
  text-transform: uppercase;
  max-width: 300px;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Hole = styled.div`
  position: absolute;
  width: 17%;
  height: 17%;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: inset 0 6px 10px rgba(0,0,0,0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: translate(-50%, -50%);
  border: 4px solid ${props => props.$active ? '#e9fe53' : 'rgba(0,0,0,0.05)'};
  z-index: 20; // Ensure holes are clickable
  
  @media (max-width: 768px) {
    width: 20%;
    height: 20%;
    border-width: 2px;
  }
  
  img { 
    max-width: 75%; 
    max-height: 75%; 
    object-fit: contain;
    transition: all 0.3s ease;
  }
`;

const FingerStop = styled.div`
  position: absolute;
  width: 80px;
  height: 35px;
  background: linear-gradient(to right, #9fa0a4, #7a7b7f);
  border-radius: 10px 40px 10px 4px;
  bottom: 15%;
  right: 15%;
  transform: rotate(45deg);
  box-shadow: 5px 5px 15px rgba(0,0,0,0.2);
  border: 1px solid #666;
  z-index: 6;
  &::after { content: ''; position: absolute; width: 25px; height: 100%; background: #7a7b7f; right: -10px; border-radius: 50%; }
`;

const StatusWrapper = styled.div`
  margin: 40px 0 80px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export default Merch;